import { Navigate, useLocation, useParams } from "react-router-dom";
import { appRoutes } from "@/app/router/appRoutes";
import {
  AGENT_ACTIVITY_ID_SEARCH_PARAM,
  AGENT_PROJECT_ID_SEARCH_PARAM,
  AGENT_SEARCH_PARAM,
  AGENT_TASK_ID_SEARCH_PARAM,
  AgentEntityRouteParamName,
  AgentSurfaceId,
} from "@/store/agent-overlay/types";

interface AgentRedirectProps {
  surfaceId: AgentSurfaceId;
  routeParamName?: AgentEntityRouteParamName;
}

const AGENT_ROUTE_PARAM_TO_SEARCH_PARAM: Record<AgentEntityRouteParamName, string> = {
  projectId: AGENT_PROJECT_ID_SEARCH_PARAM,
  taskId: AGENT_TASK_ID_SEARCH_PARAM,
  activityId: AGENT_ACTIVITY_ID_SEARCH_PARAM,
};

export const AgentRedirect = ({ surfaceId, routeParamName }: AgentRedirectProps) => {
  const location = useLocation();
  const routeParams = useParams();
  const searchParams = new URLSearchParams(location.search);

  searchParams.delete("settings");
  searchParams.delete(AGENT_PROJECT_ID_SEARCH_PARAM);
  searchParams.delete(AGENT_TASK_ID_SEARCH_PARAM);
  searchParams.delete(AGENT_ACTIVITY_ID_SEARCH_PARAM);
  searchParams.set(AGENT_SEARCH_PARAM, surfaceId);

  if (routeParamName) {
    const routeParamValue = routeParams[routeParamName];

    if (!routeParamValue) {
      searchParams.set(AGENT_SEARCH_PARAM, AgentSurfaceId.Overview);

      return <Navigate to={`${appRoutes.notesList({}).path}?${searchParams.toString()}`} replace />;
    }

    searchParams.set(AGENT_ROUTE_PARAM_TO_SEARCH_PARAM[routeParamName], routeParamValue);
  }

  return <Navigate to={`${appRoutes.notesList({}).path}?${searchParams.toString()}`} replace />;
};
